export default __webpack_public_path__ + "static/micapp-iphone-mockup-ad551ac052d200b480a061aef9393eec.png";